// @ts-check

import { useCallback } from "react";
import { useOrgConfigForTenant } from "./useOrgConfigForTenant";

/**
 * Hook for managing tenant branding config.
 */
export const useOrgBrandingForTenant = () => {
  const { loading, config, update, updating } = useOrgConfigForTenant();

  const updateBranding = useCallback(
    /**
     * @param {org_config.tenant.Branding} newBranding
     * @returns {Promise<boolean>}
     */
    async (newBranding) => {
      return update({
        branding: newBranding,
      });
    },
    [update]
  );

  return {
    loading,
    branding: config?.branding,
    update: updateBranding,
    updating,
  };
};
